module.exports = __webpack_public_path__ + "static/thpcblueeleph2-7086210626f2b9ae2f7e824ff46abc2c.jpeg";